<template>
  <div class="setting">
    <v-container>
      <h2 class="mb-2">エンドユーザの登録</h2>
      <div class="test">
        <p>Customerの設定</p>
      </div>
      <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
      <v-form ref="form" v-model="valid">
        <h3 class="mb-2">Customer名</h3>
        <v-row>
          <v-col align="right" cols="8">
            <v-text-field
              v-model="json.customer"
              placeholder="customer名を入力してください"
              :rules="[rules.required]"
              outlined
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>
        <h3 class="mb-2">各ユーザ名・メールアドレス(最大20人)</h3>
        <p>初期パスワードを入力</p>
        <v-row>
          <v-col align="right" cols="4">
            <v-text-field
              v-model="password"
              label="初期パスワード"
              placeholder="初期パスワードを入力してください"
              :rules="[rules.required]"
              outlined
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col align="right" cols="4">
            <v-select
              :items="authority"
              outlined
              v-model="json.authority"
              label="作成権限"
            ></v-select>
          </v-col>
          <v-col align="right" cols="2" class="mt-3">
            <v-btn @click="makePass" color="primary"
              >ランダムパスワード生成</v-btn
            >
          </v-col>
        </v-row>
        <div v-for="(emp, i) in json.employees" :key="i">
          <v-row>
            <v-col cols="1">
              <v-text-field :value="i + 1" disabled filled></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="json.employees[i].name"
                outlined
                label="ユーザ名"
                type="text"
                :rules="[rules.required]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="5">
              <v-text-field
                v-model="json.employees[i].mail"
                outlined
                label="メールアドレス"
                type="text"
                :rules="[rules.required, rules.mail]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="json.employees[i].attribute"
                outlined
                label="追加属性"
                type="text"
                :rules="[]"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col>
            <v-btn @click="pulus" class="ma-2">＋</v-btn>
            <v-btn @click="minus">ー</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row justify="center" class="mt-4">
        <v-btn @click="modalOpen" color="primary">employeeの作成</v-btn>
      </v-row>
      <v-dialog v-if="check_dialog" v-model="check_dialog" max-width="350">
        <check-dialog
          v-on:clickSubmit="modalClose"
          :message="'employeeを生成しますか?'"
        />
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import checkDialog from "../../components/CheckDialog/CheckDialog";
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  name: "Index",
  components: {
    checkDialog,
  },
  data: () => ({
    password: "P@ssw0rd!",
    drawer: true,
    valid: true,
    json: {
      customer: "",
      employees: [{ mail: "", name: "", password: "", attribute: "" }],
      authority: "admin",
    },
    authority: ["", "admin", "other"],

    check_dialog: false,
    rules: {
      required: (value) => !!value || "必須項目です",
      alphanumeric: (value) => {
        return /^[a-zA-Z0-9_]*$/.test(value) || "英数字のみ入力可能です。";
      },
      mail: (value) => {
        return (
          /^[a-zA-Z0-9.]{1}[A-Za-z0-9_.-]*@{1}[a-zA-Z0-9_.-]{1,}\.[a-zA-Z0-9]{1,}$/.test(
            value
          ) || "メールアドレスの形式が不正です"
        );
      },
      numonly: (value) => {
        return /^[0-9]*$/.test(value) || "数値のみ入力可能です。";
      },
    },
  }),
  methods: {
    makePass() {
      const S =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@!#$=_";
      const crypto = require("crypto");
      const N = 16;
      let tmp = Array.from(crypto.randomFillSync(new Uint8Array(N)))
        .map((n) => S[n % S.length])
        .join("");
      this.password = tmp;
    },
    pulus() {
      if (this.json.employees.length < 30) {
        this.json.employees.push(
          JSON.parse(
            JSON.stringify(this.json.employees[this.json.employees.length - 1])
          )
        );
      }
    },
    minus() {
      if (this.json.employees.length > 1) {
        this.json.employees.pop();
      }
    },
    modalOpen() {
      if (this.json.customer != "") {
        this.check_dialog = true;
      }
    },
    modalClose(value) {
      this.check_dialog = false;
      if (value) {
        this.customerGenerate();
      }
    },
    async customerGenerate() {
      if (this.$refs.form.validate()) {
        try {
          this.json.employees.forEach((e, index) => {
            this.json.employees[index].password = this.password;
          });
          const respose = await api.employeesGenerate(this.json);
          if (respose.result == "Fail") {
            alert("作成失敗:" + respose.message);
            console.log("response", respose.response);
          } else {
            alert("生成完了");
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    back() {
      history.back();
    },
  },
};
</script>
